// import external dependencies
import 'jquery';

import { library, dom, config } from '@fortawesome/fontawesome-svg-core'
config.searchPseudoElements = true;
//import { fas } from '@fortawesome/free-solid-svg-icons'
//import { far } from '@fortawesome/free-regular-svg-icons';
//import { fab } from '@fortawesome/free-brands-svg-icons';
//import { fas } from '@fortawesome/pro-solid-svg-icons';
//import { far } from '@fortawesome/pro-regular-svg-icons';
//import { fal } from '@fortawesome/pro-light-svg-icons';
import {  faTimes, faBars, faCaretLeft, faCaretRight, faCaretUp, faCaretDown, faArrowRight } from '@fortawesome/pro-solid-svg-icons';
//library.add(faCaretLeft,faCaretRight,faArrowRight);
library.add( faTimes, faBars, faCaretLeft, faCaretRight, faArrowRight, faCaretUp, faCaretDown );
dom.watch()

import AOS from 'aos';

// Import everything from autoload
import './autoload/_bootstrap.js'
import 'slick-carousel/slick/slick.min';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
AOS.init();


// WEBPACK FOOTER //
// ./scripts/main.js